/**
 * Maps a stored `make` value to its canonical brand page slug (/cars/{slug}).
 * Returns null for values that are not real brands (e.g. "SUVCars", a body
 * type typed into the make field), so they never appear as a brand link.
 */
const ALIASES: Record<string, string> = {
  mercedes: "mercedes-benz",
  "mercedes-benz": "mercedes-benz",
  mb: "mercedes-benz",
  vw: "volkswagen",
  alfaromeo: "alfa-romeo",
  landrover: "land-rover",
  rangerover: "land-rover",
};

// Category/body-type words wrongly stored as a make. Listing data is left
// untouched; these values are only kept out of brand navigation.
const NOT_A_BRAND = new Set(["suvcars", "suv", "cars", "car", "autoturism", "masina", "altele", "other", "diverse"]);

export function brandSlugFromMake(make: string | null | undefined): string | null {
  const slug = (make || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  if (!slug) return null;
  if (NOT_A_BRAND.has(slug.replace(/-/g, ""))) return null;
  return ALIASES[slug] ?? ALIASES[slug.replace(/-/g, "")] ?? slug;
}
